<template>
  <div>
    <!--销售报表-->
    <header class="form-title">
      <Row>
        <Col span="24">
          <Form inline :label-width="80">
            <FormItem label="选择时间" style="margin-right: 100px">
              <DatePicker
                split-panels
                type="daterange"
                :options="options"
                placeholder="选择日期"
                @on-change="changeTime"
                :value="date"
              ></DatePicker>
            </FormItem>
            <FormItem label="姓名:" style="margin-right: 30px">
              <strong class="result">{{selectCustomer.name}}</strong>
            </FormItem>
            <FormItem label="电话:" style="margin-right: 30px">
              <strong class="result">{{selectCustomer.phone}}</strong>
            </FormItem>
            <FormItem label="积分:" style="margin-right: 30px">
              <strong class="result">{{selectCustomer.integral}}</strong>
            </FormItem>
          </Form>
        </Col>
      </Row>
    </header>
    <Table stripe :columns="columns" :data="integralList" :loading="loadingTable">
      <template slot-scope="{row,index}" slot="integralType">
        <span>{{row.status | filtIntegralType}}</span>
      </template>
      <template slot-scope="{row,index}" slot="newIntegral">
        <span v-if="row.addintegral>=0">增加后：{{row.integral}}</span>
        <span v-else>减少后：{{row.integral}}</span>
      </template>
      <template slot-scope="{row,index}" slot="addintegral">
        <span v-if="row.addintegral">+{{row.addintegral}}</span>
        <span v-else>{{0-row.reduceintegral}}</span>
      </template>

      <template slot-scope="{row,index}" slot="addTime">
        <span>{{row.addtime | filtTime}}</span>
      </template>
    </Table>
    <div class="pageTotal">
      <Page :total="page.pageTotal" show-total :page-size="page.rows" @on-change="onChangePage" />
    </div>
  </div>
</template>
<script>
import { Exp } from "@/util/Exp";
export default {
  name: "customerAnalysis",
  data() {
    return {
      loadingTable: false,
      columns: [
        {
          title: "积分类型",
          key: "status",
          align: "center",
          slot: "integralType"
        },
        {
          title: "积分变动",
          key: "addintegral",
          align: "center",
          slot: "addintegral"
        },
        {
          title: "当前积分",
          key: "integral",
          align: "center",
          slot: "newIntegral"
        },
        { title: "订单号", key: "marketcode", align: "center" },
        { title: "时间", key: "addtime", align: "center", slot: "addTime" }
      ],
      options: {
        shortcuts: [
          {
            text: "昨日",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              return [start, start];
            }
          },
          {
            text: "今日",
            value() {
              const end = new Date();
              const start = new Date();
              return [start, end];
            }
          },
          {
            text: "近七日",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          }
        ]
      },
      formData: {
        customerid: "",
        startTime: Exp.getDays(-7),
        endTime: Exp.getDays(0),
        page: 1,
        rows: 10
      },
      date: [Exp.getDays(-7), Exp.getDays(0)],
      selectCustomer: {},
      integralList: [],
      page: {
        pageTotal: 0,
        rows: 10
      }
    };
  },
  created() {
    this.formData.customerid = this.$route.query.cusId;
    this.getCustomer();
    this.getIntegralRecordList();
  },
  methods: {
    //获取客户详情
    getCustomer() {
      this.$Api.getCustomer({ id: this.$route.query.cusId }).then(res => {
        this.selectCustomer = res.data;
      });
    },
    // 获取积分列表
    getIntegralRecordList() {
      this.loadingTable = true;
      this.$Api
        .getIntegralRecordList(this.formData)
        .then(res => {
          this.loadingTable = false;
          this.integralList = res.data;
          this.page.pageTotal = res.count;
        })
        .catch(err => {
          this.loadingTable = false;
        });
    },
    // 修改日期
    changeTime(date) {
      if (date.length) {
        this.formData.startTime = date[0];
        this.formData.endTime = date[1];
        this.getIntegralRecordList();
      }
    },
    // 修改页码
    onChangePage(num) {
      this.formData.page = num;
      this.getIntegralRecordList();
    }
  },
  filters: {
    filtIntegralType(val) {
      switch (val) {
        case "2":
          return "积分调整";
          break;
        default:
          return "销售积分";
          break;
      }
    },
    filtTime(val) {
      if (val) {
        return val.replace(".0", "");
      }
      return "";
    }
  }
};
</script>
<style lang="scss" scoped>
.form-title {
  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
</style>